import { getShowUpsellObserver } from './getShowUpsellObserver';
import { storeCartSKUs } from './storeCartSKUs';
import { upsellElements } from './upsellElements';
export const startATCUpsell = (cartProductId: string) => {
  const { cartWrapper } = upsellElements();

  // At the beginning of each upsell refresh the cart SKUs
  storeCartSKUs();

  const showUpsellObserver = getShowUpsellObserver(cartProductId);

  if (showUpsellObserver) {
    showUpsellObserver.observe(cartWrapper, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  // TODO: use class constructors to have finer control
};
